import React from "react";
import MapView from "./MapView";
import { useReceiptCardInfo } from "./handler/useReceiptCardInfo";
import { IRightCardProps } from "./types";

const RightCard: React.FC<IRightCardProps> = ({
  data,
  orderStatus,
  className,
}) => {
  const { pickup, dropoff } = useReceiptCardInfo(orderStatus, data);

  const HongKongDefaultLocation = {
    lat: 22.3193,
    lng: 114.1694,
  };

  return (
    <div className={`flex-1 h-full flex items-stretch ${className}`}>
      <div className="w-full h-full">
        <MapView
          start={{
            lat: pickup?.lat || HongKongDefaultLocation.lat,
            lng: pickup?.lng || HongKongDefaultLocation.lng,
          }}
          end={{
            lat: dropoff?.lat || HongKongDefaultLocation.lat,
            lng: dropoff?.lng || HongKongDefaultLocation.lng,
          }}
          zoom={14}
          apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY || ""}
          status={orderStatus}
          driverLocation={data.driverLocation}
          driverRoutePolyline={data.driverRoutePolyline}
          tripEstimationPolyline={data.tripEstimationPolyline}
        />
      </div>
    </div>
  );
};

export default RightCard;
